import { Image, Caption2Strong } from "@fluentui/react-components";
import { errorConstants } from "../../../utility/app-constants";
import { ErrorScreen } from "../../../assets";

/**
 * Error Screen for account summary
 * @returns 
 */
export default function AccountSummaryErrorScreen () {
    return(
        <div className="account-summary-error-screen-main">
            <div className="account-summary-error-screen-container">
                <Image className="account-summary-error-screen-image" src={ErrorScreen}/>
                <Caption2Strong>{errorConstants.errorTextTitle}</Caption2Strong>
                <Caption2Strong>{errorConstants.errorTextSubtitle}</Caption2Strong>
            </div>
        </div>
    )
}